
import { useStore } from "vuex";
import Season from './shared/seasons/season';
import { teamApi } from './shared/teams/team-api';
export default {
  setup() {
    const store = useStore();

    async function getLeagueData() {
      if (!store.state.leagueId) return;

      const league: Season[] = await teamApi.getLeagueHistory(store.state.leagueId);
      store.dispatch('setLeague', league);
    }

    function setLeagueId(leagueId: number) {
      store.dispatch("setLeagueId", leagueId);
      getLeagueData();
    }

    getLeagueData();

    return { setLeagueId, store };
  },
};
